import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { generalConsultDetailConstants } from './detail.constants';

@Component({
  selector: 'ms-consult-disease',
  templateUrl: './disease.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: GeneralConsultDiseaseComponent, multi: true }
  ]
})
export class GeneralConsultDiseaseComponent extends BaseValueAccessor<string>{
  readonly screen = generalConsultDetailConstants.disease;
  @Input() turn = -1;
  @Input() readonly = false;
  expandSection = true;
}
